import { render, staticRenderFns } from "./tareasFormulario.vue?vue&type=template&id=6d749d7d&"
import script from "./tareasFormulario.vue?vue&type=script&lang=ts&"
export * from "./tareasFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports